import { FC, useContext, useEffect } from 'react'
import styled from 'styled-components'
import { QuestionnaireContext } from '../QuestionnaireContext'
import { logout } from 'app/reducer/authSlice'
import { getClassesAction } from 'app/reducer/assessmentSlice'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch } from 'app/hooks'
import ActionButton from 'components/ActionButton'
import {
  ModalActions,
  ModalCard,
  ModalMessage,
  ModalOverlay,
  ModalTitle
} from 'components/modals/styles'

const Overlay = styled(ModalOverlay)`
  z-index: 220;
`

const Card = styled(ModalCard)`
  width: 500px;
  max-width: 500px;
`

const Header = styled.div`
  margin-bottom: 12px;
`

const Body = styled.div`
  margin-bottom: 16px;
`

const Footer = styled(ModalActions)`
  margin-top: 0;
`

const UnAvailableTestModal: FC = () => {
  const { showUnAvailableTestModal, setShowUnAvailableTestModal } =
    useContext(QuestionnaireContext)

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    const handlePress = (event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        setShowUnAvailableTestModal(false)
      }
    }

    if (showUnAvailableTestModal) {
      document.addEventListener('keydown', handlePress, false)
    }

    return () => {
      document.removeEventListener('keydown', handlePress, false)
    }
  }, [showUnAvailableTestModal, setShowUnAvailableTestModal])

  const onLogout = async () => {
    await dispatch(logout())
    navigate('/')
  }

  const onSelectAssessment = async () => {
    /**
     * Refresh the latest apo26 classroom payload before returning
     * so the student lands on an up to date assessment selection view.
     */
    setShowUnAvailableTestModal(false)
    await dispatch(getClassesAction())
    navigate('/classroom')
  }

  if (!showUnAvailableTestModal) return null

  return (
    <div className='mainContent-backDrop'>
      <Overlay>
        <Card
          role='dialog'
          aria-modal='true'
          aria-labelledby='unavailable-test-modal-title'
        >
          <Header>
            <ModalTitle id='unavailable-test-modal-title'>
              Assessment Unavailable
            </ModalTitle>
          </Header>
          <Body>
            <ModalMessage>This assessment is no longer available.</ModalMessage>
          </Body>
          <Footer>
            <ActionButton
              label='Log Out'
              variant='error'
              width={98}
              onClick={onLogout}
            />
            <ActionButton
              label='Select Another Assessment'
              variant='success'
              width={230}
              onClick={onSelectAssessment}
            />
          </Footer>
        </Card>
      </Overlay>
    </div>
  )
}

export default UnAvailableTestModal
